import React, { useContext, useEffect, useState } from "react"
import {
  TableRow,
  TableCell,
  Table,
  TableContainer,
  TableBody,
} from "@material-ui/core"
import { stableSort, getComparator } from "App/Component/ui/datatable/utils"
import {
  DatatablesFooter,
  MasterButton,
  ModalDeleteConfirm,
  TableAction,
  TableCellDefault,
  TableHeader,
} from "App/Component/ui"

import { useDatatables } from "App/hooks"
import { Add } from "@material-ui/icons"
import { FormContext } from "../../context/FormContext"
import { STYLE_DEFAULT_MASTER } from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
} from "App/utils/helpers"
import {
  headCells,
  deleteDitanggungById,
  ModalTambahDitanggung,
} from "./helpers"
import { STATUS_KUNCI_TAGIHAN } from "utils/billing"

export default function TabDitanggung({ rows, setNewData, setRows }) {
  const { formData, setFormData } = useContext(FormContext)
  const classes = STYLE_DEFAULT_MASTER()
  const [total, setTotal] = useState(0)
  const [ditanggungID, setDitanggungID] = useState(null)
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  const [showModal, setShowModal] = useState(false)
  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    withMemo: false,
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
    defaultOrder: "asc",
  })

  useEffect(() => {
    ;(async () => {
      await setNewData()
      setNewTotal()
    })()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const setNewTotal = () => {
    let total2 = 0
    rows.map((e) => {
      return (total2 += parseFloat(e.jumlah))
    })
    setTotal(total2)
  }

  async function deleteList() {
    const res = await deleteDitanggungById(ditanggungID)
    if (res.state) {
      setFormData({
        ...formData,
        reload_final_jasmed: !formData.reload_final_jasmed,
      })
      defaultToastSuccess(res.message)
      await setNewData()
    } else {
      defaultToastError(res.message)
    }
    setShowModalDeleteConfirm(false)
  }

  function clickDelete(row) {
    setDitanggungID(row.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  return (
    <>
      {showModal && (
        <ModalTambahDitanggung
          setShowModal={() => setShowModal(false)}
          setNewData={setNewData}
          tagihanID={formData.tagihan_id}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {formData.status_tagihan === STATUS_KUNCI_TAGIHAN && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <MasterButton
            type={"button"}
            color="green"
            outline={true}
            onClick={() => setShowModal(!showModal)}
            name="Tambah Ditanggung"
            size="sm"
            withIcon={true}
            icon={
              <Add
                width="15px"
                height="15px"
                style={{
                  marginLeft: "-0.5rem",
                }}
              />
            }
          />
        </div>
      )}

      <TableContainer
        className="custom-scrollbar"
        style={{
          background: "#FAFAFA",
        }}
      >
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <>
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "#fff",
                      }}
                    >
                      <TableCell
                        width="5%"
                        component="th"
                        scope="row"
                        padding="none"
                        align="center"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="none">
                        <TableAction
                          clickDelete={() => clickDelete(row)}
                          isUpdate={false}
                        />
                      </TableCell>
                      <TableCell align="left">{row.id}</TableCell>

                      <TableCell align="left">{row.keterangan}</TableCell>
                      <TableCell align="right" width={"10%"}>
                        {formatNumber(row.jumlah)}
                      </TableCell>
                      <TableCell align="left">
                        {row.isbpjs ? "BPJS" : "NON BPJS"}
                      </TableCell>
                      <TableCellDefault row={row} />
                    </TableRow>
                  </>
                )
              })}
            {rows.length > 0 && (
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="right" colSpan={3}>
                  Total
                </TableCell>
                <TableCell align="right">{formatNumber(total)}</TableCell>
                <TableCell colSpan={5}></TableCell>
              </TableRow>
            )}

            {rows.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  )
}
